import React from "react";
import { Box, CircularProgress } from "@mui/material";

interface ProgressIndicatorProps {
  noPadding?: boolean;
}

export default function ProgressIndicator({
  noPadding,
}: ProgressIndicatorProps): React.ReactElement {
  return (
    <Box display="flex" justifyContent="center" py={noPadding ? 0 : 4}>
      <CircularProgress color="secondary" />
    </Box>
  );
}
